import { render, staticRenderFns } from "./SupplierNotesColumn.vue?vue&type=template&id=58d4eadc&"
import script from "./SupplierNotesColumn.vue?vue&type=script&lang=js&"
export * from "./SupplierNotesColumn.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports